import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { ProtocolAudit, ProtocolAuditFilter } from './protocol';
import { catchError, finalize } from 'rxjs/operators';

import { ProtocolService } from '../services/protocol.service';
import { of } from 'rxjs';

export class ProtocolAuditDataSource implements DataSource<ProtocolAudit> {

    private protocolsSubject = new BehaviorSubject<ProtocolAudit[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

    constructor(private service: ProtocolService) { }

    connect(_collectionViewer: CollectionViewer): Observable<ProtocolAudit[]> {
        return this.protocolsSubject.asObservable();
    }

    disconnect(_collectionViewer: CollectionViewer): void {
        this.protocolsSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadProtocolAudit(id: number, filter = new ProtocolAuditFilter()): void {

        this.loadingSubject.next(true);

        this.service.getAudit(id, filter).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.protocolsSubject.next(data.content as ProtocolAudit[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.protocolsSubject.next(data as ProtocolAudit[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.protocolsSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }
}
